var _path;
import * as React from "react";
function SvgHurricane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17.959,0.5 H 6 c 0,0 1.953125,4.3172276 1.953125,6.8320312 0,2.2907126 -2.6559146,4.5223298 -1.7792969,6.6386718 C 6.8846738,15.686836 11,19.814453 11,19.814453 v 2.917969 L 6,23.5 H 17.958984 L 13,22.732422 v -2.917969 c 0,0 4.236581,-4.090798 4.958984,-5.84375 C 18.835479,11.843839 16.100682,9.6322208 16.070312,7.3320312 16.036822,4.7954668 17.959,0.5 17.959,0.5 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurricane);
export default __webpack_public_path__ + "static/media/Hurricane.f791e31caa52536bf1427a9c8989b203.svg";
export { ForwardRef as ReactComponent };